export default __webpack_public_path__ + "static/media/mus-cold.e1ac4a47.mp4";